import React from "react"

export default function HamburgerIcon(props) {
  return (
    <svg
      width="28"
      height="25"
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.660019 1.83661H16.6082C16.9728 1.83661 17.2681 1.42566 17.2681 0.918304C17.2681 0.410953 16.9728 0 16.6082 0H0.660019C0.295428 0 0.00012207 0.410953 0.00012207 0.918304C0.00012207 1.42566 0.295434 1.83661 0.660019 1.83661Z"
        fill="white"
      />
      <path
        d="M27.3401 11.2783H0.659896C0.295306 11.2783 0 11.6893 0 12.1966C0 12.704 0.295312 13.1149 0.659896 13.1149H27.3401C27.7047 13.1149 28 12.704 28 12.1966C28 11.6893 27.7047 11.2783 27.3401 11.2783Z"
        fill="white"
      />
      <path
        d="M27.3401 22.5571H0.659896C0.295306 22.5571 0 22.9681 0 23.4754C0 23.9828 0.295312 24.3937 0.659896 24.3937H27.3401C27.7047 24.3937 28 23.9828 28 23.4754C28 22.9681 27.7047 22.5571 27.3401 22.5571Z"
        fill="white"
      />
    </svg>
  )
}
